<template>
  <div class="claim-daily-container">
    <v-snackbar class="pa-0" light timeout="-1" v-model="alertShow" width="fit-content" style="z-index:1000 !important;top:4%" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'check_circle' : 'cancel'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <v-card class="claim-daily-wrapper">
      <v-card style="background-color: transparent !important;">
        <div class="container-reward">
          <div class="d-flex pa-3 align-center">
            <img loading="lazy" width="30px" height="30" src="/static/image/reward/Profile_CheckIn.png" />
            <h3 class="white--text pl-3">{{ $t(`label.dailyCheckIn`) }}</h3>
          </div>
          <div class="daily-container">
            <v-row no-gutters class="d-block dialog-row">
              <v-row no-gutters justify="center">
                <v-col v-if="false" cols="12" class="px-5 py-5">
                  <v-card elevation="0" style="background-color: transparent !important;">
                    <v-row no-gutters align="center">
                      <v-col cols="auto" class="text-right">
                        <img loading="lazy" src="/static/image/icon/coinicon.png" class="mt-1 coinsimg" style="width: 55px !important; height: 45px !important;" />
                      </v-col>
                      <v-col cols="auto" class="white--text pl-2 text-left" style="font-size:14px">
                        {{ memberInfo.rewardBalance ? memberInfo.rewardBalance : 0 }}
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" class="" :class="$vuetify.breakpoint.mdAndDown ? 'px-5' : 'px-5'">
                  <v-row no-gutters justify="center">
                    <v-col cols="3" v-for="(r, index) in dailyRewards" :key="index">
                      <v-row no-gutters class="daily-coins-progress pa-2">
                        <v-col class="daily-coin-container pa-2" :class="getCoinStatusClass(r)">
                          <v-row no-gutters>
                            <v-col cols="12" class="text-center">
                              <img loading="lazy" class="coinsimg" :src="getCoinsImg(r)" />
                            </v-col>
                            <v-col cols="12" class="white--text text-center">
                              {{ r.coins }}
                            </v-col>
                          </v-row>
                        </v-col>
                        <!-- <v-col>
                      <v-divider v-if="index !== dailyRewards.length - 1" class="coin-divider"></v-divider>
                    </v-col> -->
                      </v-row>
                      <v-col cols="12" class="white--text text-center">
                        {{ days[r.day] }}
                      </v-col>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </div>
          <div class="bottom-checkin">
            <v-col cols="12" class=" d-flex justify-center align-center" :class="$vuetify.breakpoint.mdAndDown ? 'px-2' : 'px-5'">
              <app-button class="button-checkin " :action="this.checkInDay" :title="$t(`button.checkInToday`)"></app-button>
            </v-col>
          </div>
        </div>
        <div v-if="false" style="background-color: #F3F5F6;">
          <div class="container-reward">
            <h3 style="padding: 20px 20px 20px 10px;">{{ $t(`label.extraRewards`) }}</h3>
            <div>
              <div style="padding-bottom: 10px;">
                <v-row justify="center" align="center" style="margin-bottom: 10px;" class="extrarewards mx-3">
                  <v-col cols="6" class="center-center">
                    <img loading="lazy" src="/static/image/reward/coins.png" height="120px" width="150px" />
                  </v-col>
                  <v-col cols="6" style="justify-content: center; display: flex;">
                    <v-col cols="12" style="padding: 0px !important;">
                      <h5 class="subtitle-extra">{{ $t(`label.depositgetfreecoin`) }}</h5>
                      <v-spacer></v-spacer>
                      <!--              <button class="getmorecoins">Claim Now</button>-->
                      <div @click="navigateToCoinPage()" class="center-center">
                        <button class="claimnow">{{ $t(`label.claimNow`) }}</button>
                      </div>
                    </v-col>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
          <div style="background-color: #F3F5F6;">
            <div class="container-reward">
              <h3 style="padding: 20px 20px 20px 10px;">Extra Benefits</h3>
              <div>
                <div style="padding-bottom: 10px;">
                  <v-row justify="center" align="center" style="margin-bottom: 10px;" class="extrarewards mx-3">
                    <v-col cols="6" class="center-center">
                      <img loading="lazy" src="/static/image/reward/wheel.png" height="120px" width="150px" />
                    </v-col>
                    <v-col cols="6" style="justify-content: center; display: flex;">
                      <v-col cols="12" style="padding: 0px !important;">
                        <h5 class="subtitle-extra">{{ $t(`label.fortuneSpin`) }}</h5>
                        <v-spacer></v-spacer>
                        <!--              <button class="getmorecoins">Claim Now</button>-->
                        <div @click="navigateWOFPage()" class="center-center">
                          <button class="claimnow">{{ $t(`label.spinNow`) }}</button>
                        </div>
                      </v-col>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center" style="margin-bottom: 10px;" class="extrarewards mx-3">
                    <v-col cols="6" class="center-center">
                      <img loading="lazy" src="/static/image/reward/vouncher.png" height="120px" width="150px" />
                    </v-col>
                    <v-col cols="6" style="justify-content: center; display: flex;">
                      <v-col cols="12" style="padding: 0px !important;">
                        <h5 class="subtitle-extra">{{ $t(`label.claimVoucher`) }}</h5>
                        <v-spacer></v-spacer>
                        <!--              <button class="getmorecoins">Claim Now</button>-->
                        <div @click="navigateToVoucherPage()" class="center-center">
                          <button class="claimnow">{{ $t(`label.claimNow`) }}</button>
                        </div>
                      </v-col>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-card>
  </div>
  <!--  <div>-->
  <!--    <h3 style="padding-left: 20px">Get More Coins </h3>-->
  <!--    <div class="center" style="display: contents"></div>-->
  <!--  </div>-->
</template>

<script>
import { DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper, locale, formValidator, errorCodeHelper } from '@/util'
import { MEMBER_DETAIL } from '@/store/member.module'
import { WHEEL_MODULE } from '@/store/wheel.module'
import {
  REWARD_GET_WALLET_LOG,
  REWARD_GET_CHECK_IN_DAY,
  REWARD_POST_CHECK_IN_DAY,
  REWARD_ACCEPT_CHALLENGE,
  REWARD_GET_MEMBER_CHALLENGE,
  REWARD_GET_DAILY_CHECK_IN_PRIZE_LIST,
  REWARD_RESET_POST_CHECK_IN_DAY,
  REWARD_CONFIGURATION_STATUS
} from '@/store/reward.module'
import { GRAB_COIN_SETTING } from '@/store/bonus.module'

export default {
  name: 'dailycheckin',
  data: () => ({
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
    coinStatus: '',
    dailyRewardsDialogShow: false,
    dateMenu: false,
    dates: ['', ''],
    dayOfWeekNumber: new Date().getDay(),
    devicePlatform: DevicePlatform,
    validator: formValidator,
    currentCurrency: uiHelper.getCurrency(),
    transactionList: [],
    dailyRewards: [],
    headers: [
      {
        text: 'transactionDate',
        align: 'start',
        sortable: true,
        value: 'member_id'
      },
      {
        text: 'transactionId',
        value: 'membercode',
        sortable: false
      },
      {
        text: 'balanceBefore',
        value: 'commission',
        sortable: false
      },
      {
        text: 'balanceAfter',
        value: 'status',
        sortable: false
      },
      {
        text: 'amount',
        value: 'status',
        sortable: false
      },
      {
        text: 'activity',
        value: 'status',
        sortable: false
      }
    ],
    routeName: ROUTE_NAME,
    days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
    pagination: {},
    selectedPage: 1
  }),
  created() {
    this.getDailyCheckInPrizeList()
    this.getGrabCoinSetting()
    this.getRewardWalletLog()
    this.getRewardCheckInDay()
    this.getChallengeByMember()
    this.getMemberDetail()
    this.getWOF()
    this.getGrabCoinSetting()
    this.getConfigurationStatus()
  },
  computed: {
    dateRangeText: {
      get() {
        let startDate = this.dates[0] ? this.dates[0] : ''
        let endDate = this.dates[1] ? this.dates[1] : ''
        return startDate + ' - ' + endDate
      },
      set(dateRange) {
        this.dates = []
      }
    },
    rewardWalletLog() {
      return this.$store.state.reward.rewardWalletLog.data
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    memberChallenge() {
      return this.$store.state.reward.memberChallenge
    },
    rewardCheckInDay() {
      return this.$store.state.reward.checkInDay
    },
    checkInDayResponse() {
      return this.$store.state.reward.checkInDayResponse.complete
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    dailyCheckInPrizeList() {
      return this.$store.state.reward.dailyCheckInPrizeList
    },
    grabCoin() {
      let d = this.$store.state.bonus.grabCoinSettings
      return d
    },
    configuration() {
      let d = this.$store.state.reward.configurationStatus
      if (d.daily_check_in.enabled) {
        this.dailyRewardsDialogShow = true
      }
      return d
    }
  },
  watch: {
    rewardWalletLog() {
      this.transactionList = this.$store.state.reward.rewardWalletLog.data
      this.pagination = this.$store.state.reward.rewardWalletLog.pagination
    },
    dailyCheckInPrizeList() {
      this.dailyRewards = this.$store.state.reward.dailyCheckInPrizeList[0].daily_coins_given
    },
    checkInDayResponse() {
      if (this.$store.state.reward.checkInDayResponse.complete) {
        this.checkInComplete(this.$store.state.reward.checkInDayResponse)
      }
    }
  },
  methods: {
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    navigateToVoucherPage() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.CLAIM_VOUCHER
      })
    },
    getConfigurationStatus() {
      let filter = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${REWARD_CONFIGURATION_STATUS}`, { filter })
    },
    selectedDate() {
      if (this.dates[0] && this.dates[1]) {
        let self = this
        setTimeout(function() {
          self.dateMenu = false
        }, 500)
      }
    },
    checkInComplete(res) {
      if (res.success) {
        this.openAlert(true, locale.getMessage(`message.checkedIn`))
        this.getMemberDetail()
        this.getRewardCheckInDay()
        this.getRewardWalletLog()
        this.closeDailyRewardsDialog()
      } else {
        this.openAlert(false, errorCodeHelper.getErrorCodeDesc(res.code))
        this.getRewardCheckInDay()
        this.getRewardWalletLog()
        this.closeDailyRewardsDialog()
      }
      this.$store.dispatch(`${REWARD_RESET_POST_CHECK_IN_DAY}`)
    },
    getCoinStatusClass(reward) {
      if (this.rewardCheckInDay.includes(reward.day)) {
        return 'checked' // Checked: Add a border
      } else if (reward.day < this.dayOfWeekNumber && reward.day != 0) {
        return 'passed' // Passed: Add a gray background
      } else {
        return 'present' // Present: Normal
      }
    },
    getCoinsImg(reward) {
      let img = '/static/svg/coin_checked.svg'
      let img2 = '/static/svg/coin_unchecked.svg'
      let img3 = '/static/image/icon/coinicon.png'
      if (this.rewardCheckInDay.includes(reward.day)) {
        this.present = 'checked'
        return '/static/image/icon/check_in_coins.png'
      } else {
        if (reward.day < this.dayOfWeekNumber && reward.day != 0) {
          this.coinStatus = 'passed'
          return '/static/image/icon/check_in_coins.png'
        } else {
          this.coinStatus = 'present'
          return '/static/image/icon/check_in_coins.png'
        }
      }
    },
    getMemberDetail() {
      if (this.isLoggedIn) this.$store.dispatch(`${MEMBER_DETAIL}`)
    },
    changePage(targetPage) {
      this.selectedPage = targetPage
      this.getRewardWalletLog()
    },
    filterListByDate() {
      this.getRewardWalletLog()
    },
    getRewardWalletLog() {
      let obj = {
        size: 20,
        page: this.selectedPage,
        startTime: this.dates[0],
        endTime: this.dates[1]
      }
      this.$store.dispatch(`${REWARD_GET_WALLET_LOG}`, { obj })
    },
    getChallengeByMember() {
      if (this.isLoggedIn) this.$store.dispatch(`${REWARD_GET_MEMBER_CHALLENGE}`)
    },
    getDailyCheckInPrizeList() {
      let obj = {
        id: 2
      }
      this.$store.dispatch(`${REWARD_GET_DAILY_CHECK_IN_PRIZE_LIST}`, { obj })
    },
    getRewardCheckInDay() {
      this.$store.dispatch(`${REWARD_GET_CHECK_IN_DAY}`)
    },
    acceptChallenge() {
      let obj = {
        id: 2
      }
      this.$store.dispatch(`${REWARD_ACCEPT_CHALLENGE}`, { obj })
    },
    checkInDay() {
      let obj = {
        checkinDay: this.dayOfWeekNumber
      }
      this.$store.dispatch(`${REWARD_POST_CHECK_IN_DAY}`, { obj })
    },
    changePasswordResponseCompleteDialog(response) {
      if (response.code != 0 && !response.success) {
        this.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
      } else {
        this.openAlert(true, locale.getMessage(`message.memberPasswordUpdated`))
      }
    },
    clearFilter() {
      this.dates = []
      this.getRewardWalletLog()
      //this.onChangeTab(this.selectedTab)
    },
    closeDailyRewardsDialog() {
      this.dailyRewardsDialogShow = false
    },
    openDailyRewardsDialog() {
      if (this.memberChallenge.fk_challenge_id != 2) {
        this.acceptChallenge()
      }
      this.dailyRewardsDialogShow = true
    },
    navigateWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF
        })
      }
    },
    getWOF() {
      let currency = uiHelper.getCurrency()
      let filter = {
        currency: currency
      }
      this.$store.dispatch(`${WHEEL_MODULE}`, { filter })
    },
    getGrabCoinSetting() {
      let filter = {
        currency: uiHelper.getCurrency()
      }
      this.$store.dispatch(`${GRAB_COIN_SETTING}`, { filter })
    },
    navigateToCoinPage() {
      this.$router.push({
        name: ROUTE_NAME.FUNDS
      })
    }
  }
}
</script>

<style lang="scss">
.claim-daily-container {
  background-size: cover;
  background-image: url(/static/image/reward/daily_check_in_background.png);
  .claim-daily-wrapper {
    background: transparent !important;
  }
  .daily-coin-container {
    background: transparent linear-gradient(180deg, #770073 0%, #0e181d 100%) 0% 0% no-repeat padding-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    height: 90px;
    border: 1px solid #c817c2;
    &.passed {
      filter: grayscale(100%); /* Convert to grayscale */
      opacity: 0.6; /* Reduce visibility slightly */
    }
    &.checked {
      border-color: 1px solid #ffc000 !important;
    }
  }
}
.coin-container-reward {
  border-radius: 0px !important;
  background: transparent linear-gradient(179deg, #ff5ae4 0%, #c817c2 0%, #000000 100%);
}

.coinsimg {
  width: 60%;
}
.center-center {
  justify-content: center;
  display: flex;
}
.extrarewards {
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #00000042;
  border-radius: 5px;
}
.subtitle-extra {
  justify-content: center;
  display: flex;
  padding-bottom: 10px;
}
.claimnow {
  height: 36px;
  width: 140px;
  background: transparent linear-gradient(180deg, #0047ff 0%, #5a00b4 100%);
  color: white;
  text-align: center;
  border-radius: 5px;
  padding-bottom: 2px;
  font-size: 15px;
}
.button-checkin {
  width: 80%;
  padding: 0 7px;
  color: #000000 !important;
  background: #ffc000 !important;
  //background-image: linear-gradient(to bottom, #ffab2d, #ff7700);
}
.daily-container {
  //background-image: url(/static/image/reward/checkin.png);
  background-size: cover;
  border-top-left-radius: 30px !important;
  border-top-right-radius: 30px !important;
  height: auto;
  margin-left: 12px;
  margin-right: 12px;
  .dialog-row {
    background: transparent !important;
  }
}
.bottom-checkin {
  //background: url(/static/image/reward/Purple_line.png), linear-gradient(to bottom, #0045ff, #6900b8);
  border-bottom-left-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 12px;
  margin-right: 12px;
}
@media screen and (min-width: 600px) {
  .coinsimg {
    width: 65px !important;
    height: 50px !important;
  }
}

@media screen and (min-width: 750px) {
  .coinsimg {
    width: 70px !important;
    height: 55px !important;
  }
  .container-reward {
    padding: 0px;
    //margin-left: 70px;
    //margin-right: 70px;
  }
  .daily-container {
    max-width: 1300px;
    height: 300px;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .bottom-checkin {
    max-width: 1300px;
  }
}
</style>
